import(/* webpackMode: "eager" */ "/frontend/src/app/[lang]/[currency]/(chrome)/terms-and-conditions/page.tsx")